import * as yup from 'yup';

const botPromtTriggerSettingsSchema = yup.array().of(
  yup.object().shape({
    active: yup.bool(), // required
    id: yup.number(),
    name: yup.string(), // required
    priority: yup.number(), // required
    rules: yup.object().shape({
      clause: yup.string().oneOf(['AND', 'OR']),
      rule_list: yup.array().of(
        yup.object().shape({
          operator: yup.string(),
          value: yup.mixed(),
          variable: yup.string(),
          meta: yup.object(),
        })
      ), // minimum 1
    }),
    timeout: yup.number(), // positive
    variants: yup.array().of(
      yup.object().shape({
        // values below should be non empty
        actionable_text: yup.string(),
        gogo_message: yup.string(),
        message: yup.string(),
        quick_reply: yup.array(),
      })
    ), // at least 1
  })
);

export default botPromtTriggerSettingsSchema;
